import { Input, Directive } from '@angular/core';

import {
  FormGroup,
  FormControl
} from '@angular/forms';

import {
  DynamicFieldConfig
} from '../../../../../core/models/dynamic-form.models';

@Directive()
export abstract class LineCellBaseComponent {

  @Input()
  row!: FormGroup;

  @Input()
  col!: DynamicFieldConfig;

  @Input()
  rowIndex!: number;

  @Input()
  columnIndex!: number;

  get control(): FormControl {

    return this.row.get(
      this.col.name
    ) as FormControl;
  }

  protected getCellKey(): string {

    return `${this.rowIndex}-${this.columnIndex}`;
  }

  getError(): string {

    const ctrl = this.control;

    if (!ctrl || !ctrl.errors) {
      return '';
    }

    if (ctrl.errors['required']) {
      return `${this.col.label} is required`;
    }

    if (ctrl.errors['min']) {
      return 'Minimum value invalid';
    }

    if (ctrl.errors['max']) {
      return 'Maximum value exceeded';
    }

    if (ctrl.errors['pattern']) {
      return 'Invalid format';
    }

    return 'Invalid value';
  }

  getDisplayLabel(): string {

    const value =
      this.control?.value;

    if (!value) {
      return '';
    }

    if (typeof value === 'object') {

      return (
        value.label ||

        value[
          this.col.dataSource?.labelField ||
          'name'
        ] ||

        ''
      );
    }

    return String(value);
  }
}